import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { createProject, listProjects, deleteProject } from "../api/projects";
import type { Project } from "../api/projects";
import { logout } from "../api/auth";
import { useAuthStore } from "../store/auth";

function bytesToHuman(b: number): string {
  if (b < 1024) return `${b} B`;
  if (b < 1024 ** 2) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 ** 3) return `${(b / 1024 ** 2).toFixed(1)} MB`;
  return `${(b / 1024 ** 3).toFixed(2)} GB`;
}

export default function DashboardPage() {
  const user = useAuthStore((s) => s.user)!;
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    listProjects().then((p) => { setProjects(p); setLoading(false); });
  }, []);

  async function onCreate() {
    const name = prompt("Nombre del proyecto:");
    if (!name) return;
    setCreating(true);
    try {
      const p = await createProject(name.trim());
      nav(`/editor/${p.id}`);
    } finally { setCreating(false); }
  }

  async function onDelete(p: Project) {
    if (!confirm(`Borrar "${p.name}" y sus clips?`)) return;
    await deleteProject(p.id);
    setProjects((arr) => arr.filter((x) => x.id !== p.id));
  }

  const pct = Math.round((user.storage_used_bytes / user.quota_bytes) * 100);

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="brand">Videotool</div>
        <div className="spacer" />
        <div className="user-chip">
          {bytesToHuman(user.storage_used_bytes)} / {bytesToHuman(user.quota_bytes)} ({pct}%)
        </div>
        <div className="user-chip">{user.display_name || user.email}</div>
        {user.is_staff && (
          <Link to="/admin/invitaciones">
            <button>Invitaciones</button>
          </Link>
        )}
        <button onClick={logout}>Salir</button>
      </div>

      <div className="dashboard">
        <header>
          <h1>Mis proyectos</h1>
          <button className="primary" onClick={onCreate} disabled={creating}>
            + Nuevo proyecto
          </button>
        </header>
        {loading ? (
          <p>Cargando…</p>
        ) : projects.length === 0 ? (
          <p style={{ color: "var(--text-dim)" }}>
            Todavía no tienes proyectos. Crea el primero arriba.
          </p>
        ) : (
          <div className="project-grid">
            {projects.map((p) => (
              <div key={p.id} className="project-card" onClick={() => nav(`/editor/${p.id}`)}>
                <h3>{p.name}</h3>
                <div className="meta">
                  {p.width}×{p.height} · {p.fps}fps · {(p.duration_ms / 1000).toFixed(1)}s
                </div>
                <div className="meta" style={{ marginTop: 8, fontSize: 11 }}>
                  Actualizado {new Date(p.updated_at).toLocaleString()}
                </div>
                <button
                  className="danger"
                  onClick={(e) => { e.stopPropagation(); onDelete(p); }}
                  style={{ marginTop: 10, fontSize: 11, padding: "4px 8px" }}
                >
                  Borrar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
